import React from 'react';
import { Grid, Typography, Box, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MappedText from "../../../../../../../../../instand/reports/create-report/shared-components/mapText";
import CaButton from "../../../../../../../../../../gpap-lib/components/shared-components/CaButton";
import { useTranslation } from "react-i18next";

const GenericForm = ({
                         isFlagged,
                         deleteFunction,
                         deleteSpec,
                         dataType,
                         handleTextChange,
                         dataComments,
                         mappedTextIntro, // Unique intro text for each form
                         deleteMappedText // Unique delete text for each form
                     }) => {
    const size = 12;
    const { t } = useTranslation();
    return (
        <Grid container direction={"column"}>
            <Grid item lg={size}>
            {isFlagged ? (
                <Grid
                item
                lg={size}
                style={{ backgroundColor: '#c6dbef', padding: '10px', borderRadius: '5px' }}
                >
                <Typography variant="subtitle1">
                    {t("evidence_tagging_flagged", { intro: mappedTextIntro })}
                </Typography>
                </Grid>
            ) : (
                <Typography variant="subtitle1">
                {t("evidence_tagging_unflagged", { intro: mappedTextIntro })}
                </Typography>
            )}
            </Grid>

            <Grid item lg={size}>
                <Box p={2}>
                    <TextField
                        style={{ width: "100%" }}
                        id="standard-multiline-static"
                        label={<MappedText text={"Interpretation"} />}
                        multiline
                        rows={4}
                        onChange={handleTextChange}
                        defaultValue={dataComments}
                    />
                </Box>
            </Grid>

            {isFlagged && (
                <Grid item lg={size}>
                    <div>
                        <CaButton
                            variant={"contained"}
                            text={deleteMappedText}
                            aria-label="delete"
                            onClick={() => deleteFunction(deleteSpec, dataType)}
                            startIcon={<DeleteIcon />}
                        />
                    </div>
                </Grid>
            )}
        </Grid>
    );
};

export default GenericForm;
